import ComingSoonCover from "@/components/ComingSoonCover";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_staff/time-and-attendance/_layout/_placeholders/attendances",
)({
  component: () => <ComingSoonCover />,
});
